module.exports = __webpack_public_path__ + "img/ic-status-success.5f3c825a.png";